// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { SearchBar } from '@metarouter-private/mr-mui';

export default function SearchInput({ value, onChange }) {
  return (
    <SearchBar
      size="small"
      placeholder="Search by pipeline name..."
      value={value}
      onChange={event => onChange(event.target.value)}
      data-test-id="file-search-input"
    />
  );
}

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
